module.exports = __webpack_public_path__ + "img/Pronunciation.60a29998.svg";